/**
 * 产品相关hooks
 */

import {ChangeEvent, useEffect, useState} from 'react';
import { useRequest, useLocationQuery } from './index';

interface BackendData {
    // 技能标志
    type: string;
    appName: string;
    // 技能中文名
    appNameCh: string | null;
    // 包几个月
    months: number;
    // 价格
    price: number;
    discount: number;
    originPrice: number;
}

export function useProductSelect(payChannel = 'wechat') {
    const query = useLocationQuery();
    // 包几个月
    const [month, setMonth] = useState(() => {
        if (query) {
            return parseInt(query.months as string, 10) || 6;
        } else {
            return 6
        }
    });
    const {
        loading,
        data,
    } = useRequest<BackendData[]>({
        url: `/wechat/getproducts?payChannel=${encodeURIComponent(payChannel)}&${window.location.search.substring(1)}`,
        method: 'GET',
        defaultData: [],
        defaultIsLoading: true,
    });
    const productList = data || [];
    const currentProduct = productList.find((obj: any) => { return obj.months === month});
    // 首次请求到产品列表后，设置默认选项
    useEffect(() => {
        if (!productList || productList.length < 1) {
            return;
        }
        if (currentProduct) {
            return;
        }
        // setProduct(productList[0].appName);
        setMonth(productList[0].months);
    }, [productList, currentProduct]);
    let originPrice = '';
    let price = '--';
    if (currentProduct) {
        price = (currentProduct.price / 100).toFixed(2);
        if (currentProduct.price !== currentProduct.originPrice) {
            originPrice = (currentProduct.originPrice / 100).toFixed(2);
        }
    }
    return {
        loading,
        productList,
        month,
        setMonth,
        currentProduct,
        originPrice,
        price,
    };
}

